const footerLinks = {
  navigation: [
    { label: '每日快讯', href: '#updates' },
    { label: '热门专题', href: '#cards' },
    { label: '吃瓜目录', href: '#index' },
    { label: '独家视频', href: '#media' },
    { label: '今日猛料榜', href: '#ranking' },
    { label: '常见问题', href: '#faq' },
  ],
  connect: [
    { label: '投稿爆料', href: '#contact' },
    { label: 'APP下载', href: '#app' },
    { label: '关于我们', href: '#about' },
  ],
};

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-base">
                51
              </span>
              <span className="text-lg font-bold font-heading text-background-50">51黑料网</span>
            </div>
            <p className="text-sm text-background-50/50 leading-relaxed mb-4">
              全网吃瓜第一线，实时深扒娱乐圈最劲爆大瓜。每日更新网红反差视频、明星翻车实锤与独家泄漏秘闻，海量黑料在线免费看。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors flex items-center justify-center cursor-pointer">
                <i className="ri-weibo-line text-sm text-background-50/70"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors flex items-center justify-center cursor-pointer">
                <i className="ri-wechat-line text-sm text-background-50/70"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors flex items-center justify-center cursor-pointer">
                <i className="ri-vidicon-line text-sm text-background-50/70"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系与合作</h4>
            <ul className="space-y-2.5">
              {footerLinks.connect.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/40 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 51黑料网 版权所有 | 51黑料网 - 黑料网每日 | 免费黑料网
          </p>
          <div className="flex items-center gap-4 text-xs">
            <a href="#hero" className="text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a>
            <a href="#hero" className="text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#hero" className="text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}